<!--
 * @Author: xuqing6@hikvison.com.cn
 * @Date: 2018-11-20 15:27:47
 * @LastEditors: xuqing6@hikvison.com.cn
 * @LastEditTime: 2018-12-13 14:39:20
 -->

<template>
  <el-dialog
    title="欢迎来到萤石商业智居"
    visible
    top="180px"
    class="login-step"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    center>
      <div class="step-radio-container">
        <div class="radio-group" @click="toggleCheckRadio(1)">
          <div class="radio-group__left" >
            <input type="radio" name="item" value="1" id="radio1" :checked="checkedValue===1">
            <label for="radio1"></label>
          </div>
          <div class="radio-group__right">
            <p class="radio-group__right--top">
              使用原来的AppKey和Secret<span class="span__blue">（推荐）</span>
            </p>
            <p class="radio-group__right--bottom">
              后续支持同步原有开发者账号下的设备资源
            </p>
          </div>
        </div>
        <div class="radio-group" @click="toggleCheckRadio(2)">
          <div class="radio-group__left" >
            <input type="radio" name="item" value="2" id="radio2" :checked="checkedValue===2">
            <label for="radio2"></label>
          </div>
          <div class="radio-group__right">
            <p class="radio-group__right--top">
              不使用原来的AppKey和Secret
            </p>
            <p class="radio-group__right--bottom">
              无法同步原有开发者账号下的设备资源
            </p>
          </div>
        </div>
        <div class="next-container">
          <el-button type="primary" class="saasl-btn login-next-btn" @click="goNext">下一步</el-button>
        </div>
      </div>
  </el-dialog>
</template>
<script>
export default {
  mounted() {
    if (!this.$route.query || !this.$route.query.code) {
      // this.$router.push("/login");
    }
  },
  data() {
    return {
      checkedValue: 1
    };
  },
  methods: {
    handleClose() {
      this.$router.push("/login");
    },
    toggleCheckRadio(value) {
      console.log(this.checkedValue);
      this.checkedValue = value;
    },
    goNext() {
      if (this.checkedValue === 1) {
        this.$router.push("./step32");
      } else {
        this.$router.push("./step31");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.saasl-register-step2 {
  padding-top: 50px;
}
.login-step-title {
  color: #000;
  margin-bottom: 20px;
  text-align: center;
}
.login-step {
  .el-dialog__body {
    padding: 25px 50px 25px;
  }
  .saasl-register-step2_form .saasl-register-protocol {
    padding-left: 106px;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  button.el-button.saasl-btn.saasl-home__btn.saasl-register-step2_btn.el-button--default {
    margin-left: 106px;
  }
  .next-container {
    width: 470px;
    display: flex;
    .login-next-btn {
      flex: 1;
      margin-top: 20px;
    }
  }
}
.step-radio-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.radio-group {
  .radio-group__left {
    position: relative;
    line-height: 30px;
  }
  input[type="radio"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }
  label {
    position: absolute;
    left: 5px;
    top: 3px;
    width: 20px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #dadada;
  }
  input:checked + label {
    background-color: #95d02e;
    border: 1px solid #95d02e;
  }
  input:checked + label::after {
    position: absolute;
    content: "";
    width: 5px;
    height: 10px;
    top: 3px;
    left: 6px;
    border: 2px solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }
  display: flex;
  width: 470px;
  height: 83px;
  background-color: #f8f8f8;
  margin-bottom: 20px;
  padding-left: 70px;
  padding-top: 20px;
  cursor: pointer;
  .radio-group__left {
    width: 50px;
  }
  .radio-group__right {
    flex: 1;
    font-size: 14px;
    color: #929398;
    p {
      line-height: 24px;
    }
    .radio-group__right--top {
      color: #333333;
    }
    .span__blue {
      color: #458fff;
    }
  }
}
</style>
